import { defineStore } from 'pinia'

import axios from "@axios"
import {reportError} from "@/plugins/misc"

const baseUrl = `/var/`

export const useVarsStore = defineStore({
  id: 'vars',
  state: () => ({
    globalSettings: [],
    editingGlobalSettings: false,
    adminDirectReservationDialogVisible: false,
    adminEditingReservation: null,
  }),
  actions: {

    async getGlobalSettings() {
      try {
        let res = await axios.get(baseUrl, {
          params:{
            globalSettings: true
          }
        })
        this.globalSettings = res.data
      } catch (error) {
        console.log("ERROR 563", error)
        reportError("vars.store.js-getGlobalSettings", error.message, null,null,null, error)
      }
    },

    async saveGlobalSettings() {
      try {
        let res = await axios.put(baseUrl, this.globalSettings,{
          params:{
            globalSettings: true
          }
        })
        this.globalSettings = res.data
      } catch (error) {
        console.log("ERROR 563", error)
        reportError("vars.store.js-saveGlobalSettings", error.message, null,null,null, error)
      }
    },

  }
})
